import { ORDER_TYPES, OrderType } from "../../columns/config/types";

// Actions for the dropdown options on the UI
export const PotentialRepeatReportAction = {
  CREATE_TASK: "Create Client Task",
  CREATE_PROJECT: "Create Project",
  COPY_PRESENTATION: "Copy Presentation",
  COPY_SALES_ORDER: "Copy Sales Order",
  DISMISS: "Dismiss",
  UNDO_DISMISS: "Undo Dismiss",
} as const;

export type ActionType =
  (typeof PotentialRepeatReportAction)[keyof typeof PotentialRepeatReportAction];

// Valid actions that can be taken on an item from the potential repeat report
export const ProjectAction = {
  CREATE_TASK: "CREATE_TASK",
  CREATE_PROJECT: "CREATE_PROJECT",
  COPY_PRESENTATION: "COPY_PRESENTATION",
  COPY_SALES_ORDER: "COPY_SALES_ORDER",
} as const;

export type ProjectActionType =
  (typeof ProjectAction)[keyof typeof ProjectAction];

export const ProjectActionLabel = {
  [ProjectAction.CREATE_TASK]: "Task Created",
  [ProjectAction.CREATE_PROJECT]: "Project Created",
  [ProjectAction.COPY_PRESENTATION]: "Presentation Copied",
  [ProjectAction.COPY_SALES_ORDER]: "Sales Order Copied",
} as const;

export interface ProjectActionPayload {
  'project_action_id': string;
  'action_type': ProjectActionType;
  'parent_id': string;
  'date_created': string;
  'parent_job_number': number;
  'parent_form_number': number;
};

export const mapOrderTypeToAction: Partial<Record<OrderType, ProjectActionType>> = {
  [ORDER_TYPES.PRESENTATION]: ProjectAction.COPY_PRESENTATION,
  [ORDER_TYPES["SALES ORDER"]]: ProjectAction.COPY_SALES_ORDER,
};

export const mapActionTypetoOrderType: Partial<Record<ProjectActionType, OrderType>> = {
  [ProjectAction.COPY_PRESENTATION]: ORDER_TYPES.PRESENTATION,
  [ProjectAction.COPY_SALES_ORDER]: ORDER_TYPES["SALES ORDER"],
};